import { mapGetters, mapActions } from 'vuex';

import SharedHeader from '@/components/SharedHeader.vue';
import SharedFooter from '@/components/SharedFooter.vue';
import Spinner from '@/components/Spinner.vue';
import { PASSWORD_SUCCESS_PAGE } from '@/constants/routes';
import { CaptchaMixin } from '../Mixin';
import { LOADING_MESSAGE } from './Reset.constants';

export default {
  name: 'Reset',

  mixins: [CaptchaMixin],

  components: {
    SharedHeader,
    SharedFooter,
    Spinner,
  },

  data: () => {
    return {
      loadingMessage: LOADING_MESSAGE,
      password: '',
      passwordConfirm: '',
      objError: {
        password: {
          pristine: true,
          invalid: false,
        },
        passwordConfirm: {
          pristine: true,
          invalid: false,
        },
        passwordMismatch: false,
        usedLink: false,
        failed: false,
      },
      linkValid: true,
      validStatus: 0,
    };
  },

  computed: {
    ...mapGetters({
      immLoading: 'immLoading',
    }),

    c_isSubmitDisabled() {
      return (
        !this.password ||
        !this.passwordConfirm ||
        this.objError.passwordMismatch ||
        !this.c_isCaptchaReady
      );
    },
  },

  methods: {
    ...mapActions('Password/Reset', {
      ma_passwordResetValid: 'passwordResetValid',
      ma_passwordResetResetWithToken: 'passwordResetResetWithToken',
    }),

    passwordChanged() {
      this.objError.failed = false;
      this.objError.passwordMismatch =
        this.password && this.passwordConfirm && this.password !== this.passwordConfirm;
    },

    beforeHandleChangeCaptcha() {
      this.objError.failed = false;
    },

    async next() {
      const res = await this.ma_passwordResetResetWithToken({
        password: this.password,
        captcha: this.captcha,
        token: this.$route.query.token ? this.$route.query.token : '',
      });
      this.validStatus = res.data.status;
      if (res.data.status == 200) {
        this.linkValid = true;
        this.$router.push(PASSWORD_SUCCESS_PAGE);
      } else {
        this.objError.failed = true;
        if (res.data.status == -6) {
          this.objError.captchaError = true;
          this.refresh();
        } else if (res.data.status == -2) {
          this.objError.captchaError = true;
          this.refresh();
        } else if (res.data.status == -7) {
          this.linkValid = false;
          this.objError.usedLink = true;
          this.refresh();
        }
      }
    },

    async _resetCreated() {
      const res = await this.ma_passwordResetValid({
        token: this.$route.query.token ? this.$route.query.token : '',
      });
      if (res.data.status == 200) {
        this.linkValid = true;
      } else if (res.data.status == -5) {
        this.linkValid = false;
        this.validStatus = -5;
      } else if (res.data.status == -6) {
        this.linkValid = false;
        this.validStatus = -6;
      } else if (res.data.status == -7) {
        this.linkValid = false;
        this.validStatus = -7;
        this.objError.usedLink = true;
        this.refresh();
      }
    },
  },

  created() {
    this._resetCreated();
  },
};
